import React from "react";

export default React.createContext({
    headband: {
        title : "",
        icon : "",
        color : ""
    },
    setHeadband: value => {}
});
